import React, { useRef, useState } from "react";
import "./css/Services.css";
import { Link } from "react-router-dom";
import ConfirmationModal from "../components/ConfirmationModal";


const services = [
    {
        id: 1,
        title: "NFC Cards for Google Reviews",
        description: "NFC cards, acrylic stands and stickers that send your customers straight to your Google review page. Tap and done.",
        icon: "📇",
        link: "/nfc-reviews",
    },
    {
        id: 2,
        title: "Digital Menus (QR Code / NFC)",
        description: "Interactive digital menus for restaurants, bars and cafés — accessed via QR Code or NFC tap, always up to date, no printing needed.",
        icon: "📋",
        link: "/menu-demo",
    },
    {
        id: 3,
        title: "REST API Creation",
        description: "Scalable APIs using ExpressJS, Springboot Java, Django Python with full documentation.",
        icon: "🔗",
    },
    {
        id: 4,
        title: "Website Creation",
        description: "Full websites built end-to-end — from database and backend to hosting and deployment on Vercel, Railway or a custom VPS.",
        icon: "🌐",
    },
    {
        id: 5,
        title: "Discord Bot Development",
        description: "Custom bots with slash commands, moderation, tickets, giveaways, and more.",
        icon: "🤖",
    },
    {
        id: 6,
        title: "Automation Scripts",
        description: "Automate boring tasks with Python, Node.js, or Bash scripting.",
        icon: "⚙️",
    },
    {
        id: 7,
        title: "Software Development",
        description: "Creation of Software, Business Logic and project deployment. Using C# .NET, Java or Python",
        icon: "🖥️",
    },
];

const Services = () => {
    const formRef = useRef();
    const [status, setStatus] = useState(null);

    const sendEmail = async (e) => {
        e.preventDefault();

        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData.entries());

        try {
            const response = await fetch("https://website-backend-production-2163.up.railway.app/api/email/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                setStatus("success");
                formRef.current.reset();
            } else {
                setStatus("error");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            setStatus("error");
        }
    };

    return (
        <section className="services-section">
            <Link to="/" className="home-button-gaming">Go to Home</Link>
            <div className="services-header">
                <h2 className="services-title">Services I Offer</h2>
            </div>

            <div className="services-grid">
                {services.map((service) => {
                    const CardTag = service.link ? Link : "div";
                    const cardProps = service.link
                        ? { to: service.link, className: "service-card service-card-link" }
                        : { className: "service-card" };

                    return (
                        <CardTag key={service.id} {...cardProps}>
                            <div className="service-icon">{service.icon}</div>
                            <h3 className="service-name">{service.title}</h3>
                            <p className="service-description">{service.description}</p>
                            {service.link && <span className="service-cta">Learn more →</span>}
                        </CardTag>
                    );
                })}
            </div>

            <div className="get-in-touch">
                <h3 className="ways-contact">
                    Ways to contact me:
                    <div className="icons-spot">
                        <a className="iconsAbout github" href="https://github.com/Felippefn" target="__blank" rel="noopener noreferrer">
                            <i className="bi bi-github"></i>
                        </a>
                        <a className="iconsAbout linkedin" href="https://www.linkedin.com/in/felippefn/" target="__blank" rel="noopener noreferrer">
                            <i className="bi bi-linkedin"></i>
                        </a>
                        <a className="iconsAbout email" href="mailto:flppprojects@outlook.com" target="__blank" rel="noopener noreferrer">
                            <i className="bi bi-envelope-fill"></i>
                        </a>
                        <a className="iconsAbout discord" href="https://discordapp.com/users/330511498352918529" target="__blank" rel="noopener noreferrer">
                            <i className="bi bi-discord"></i>
                        </a>
                    </div>
                </h3>
                <div className="contact-form-box">
                    <h3>Send me a message</h3>
                    <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
                        <input type="text" name="name" placeholder="Your Name" required />
                        <input type="email" name="user_email" placeholder="Your Email" required />

                        <select name="reason" required>
                            <option value="">Select Reason</option>
                            <option value="Ask for a service">Ask for a service</option>
                            <option value="General contact">General contact</option>
                            <option value="Feedback">Feedback</option>
                        </select>

                        <textarea name="message" placeholder="Describe your message..." rows="5" required></textarea>

                        <button type="submit">Send Message</button>
                    </form>
                </div>
            </div>

            <ConfirmationModal
                status={status}
                onClose={() => setStatus(null)}
                onContinue={() => setStatus(null)}
            />
        </section>
    );
};

export default Services;